import { usePathnameParts } from "@/hooks/use-pathname-parts";
import { pretty, prettyId } from "@/utils/pretty";

export function PageTitle() {
  const parts = usePathnameParts();

  const part1 = parts[0] ? " · " + pretty(parts[0], "dashes") : "";
  const part2 = parts[1] ? " · " + prettyId(parts[1]) : "";

  return <title>{`QA Tool${part1}${part2}`}</title>;
}
